import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export const Logo = ({ className, dark = false, subtitle = "West Canal Motors" }) => (
  <Link to="/" data-testid="site-logo" className={cn("group inline-flex items-center gap-3", className)}>
    <span className="relative flex items-center">
      <span className={cn("font-display text-xl sm:text-2xl font-black tracking-[-0.06em] leading-none", dark ? "text-obsidian" : "text-white")}>
        JETOUR
      </span>
      <span className="absolute -right-2 top-0 h-1.5 w-1.5 rounded-full bg-crimson transition-transform duration-500 group-hover:scale-150" />
    </span>
    <span className={cn("hidden sm:block h-6 w-px", dark ? "bg-black/20" : "bg-white/20")} />
    <span className={cn("hidden sm:block font-mono text-[10px] uppercase tracking-[0.22em]", dark ? "text-black/60" : "text-slate-400")}>
      {subtitle}
    </span>
  </Link>
);
